import type { MapperOptions } from '#layers/core/types'
import { mapperGlobalDataTheme } from '#layers/core/data-layer/global-data/mappers'
import { mapperBlockCampaignsCardsItem } from '#layers/core/data-layer/blocks/block-campaigns-cards-item/mapper-block-campaigns-cards-item'

export const mapperBlockCampaignsCards = (data: any, getUrl: Function) => {
  if (!data) {
    return null
  }
  // TODO: check if this is the right config for the image Options
  const options: MapperOptions = {
    getUrl,
    imageOptions: {
      lazy: true,
      sizes: {
        small: { width: 272, height: 153, aspectRatio: '16/9' },
        medium: { width: 576, height: 324, aspectRatio: '16/9' },
        large: { width: 576, height: 324, aspectRatio: '16/9' }
      }
    }
  }
  return {
    sys: data.sys || null,
    id: data.sys?.id || '',
    contentType: data.contentType || '',
    title: data.title || '',
    items: data.itemsCollection?.items.map((item: any) => mapperBlockCampaignsCardsItem(item, options)) || [],
    theme: mapperGlobalDataTheme(data.theme)?.theme || null
  }
}
